import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface ProjectReportParams {
  id: number;
  from: string;
  to: string;
  type: string; // 'KU' | 'P' | 'A' | 'K'
  per: string;
  custMode: { external: boolean; internal: boolean; absense: boolean };
  cust?: number | null;
  proj?: number | null;
  act?: number | null;
}

export interface ProjectReportItem {
  customername: string | null;
  endcustomer?: string;
  project_name?: string;
  external_project_name?: string;
  activity_name?: string;
  external_activity_name?: string;
  name?: string;
  employee_id?: number;
  reporteddate?: string;
  time?: number;
  sum?: number;
  prisNum?: number;
}

@Injectable({
  providedIn: 'root',
})
export class ProjectReportsService {
  constructor(@Inject(HttpClient) private http: HttpClient) {}

  getProjectReport(params: ProjectReportParams): Observable<ProjectReportItem[]> {
    let httpParams = new HttpParams()
      .set('type', params.type)
      .set('per', params.per)
      .set('custMode', JSON.stringify(params.custMode));

    if (params.cust !== null && params.cust !== undefined) {
      httpParams = httpParams.set('cust', String(params.cust));
    }
    if (params.proj !== null && params.proj !== undefined) {
      httpParams = httpParams.set('proj', String(params.proj));
    }
    if (params.act !== null && params.act !== undefined) {
      httpParams = httpParams.set('act', String(params.act));
    }

    return this.http.get<ProjectReportItem[]>(
      `/api/projreport/${params.id}/${params.from}/${params.to}`,
      { params: httpParams }
    );
  }
}
